import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateMomentAdapter } from './util/datepicker-adapter';
import { LoginModalComponent } from './login/login.component';
import { HasAnyAuthorityDirective } from './auth/has-any-authority.directive';
import { FdeGatewaySharedLibsModule } from './shared-libs.module';
import { FdeGatewaySharedCommonModule } from './shared-common.module';

@NgModule({
    imports: [FdeGatewaySharedLibsModule, FdeGatewaySharedCommonModule, LoginModalComponent],
    declarations: [HasAnyAuthorityDirective],
    providers: [{ provide: NgbDateAdapter, useClass: NgbDateMomentAdapter }],
    exports: [FdeGatewaySharedCommonModule, LoginModalComponent, HasAnyAuthorityDirective]
})
export class FdeGatewaySharedModule {
    static forRoot(): ModuleWithProviders<FdeGatewaySharedModule> {
        return {
            ngModule: FdeGatewaySharedModule
        };
    }
}
